import script from "./MyItems.vue?vue&type=script&setup=true&lang=js"
export * from "./MyItems.vue?vue&type=script&setup=true&lang=js"

import "./MyItems.vue?vue&type=style&index=0&id=408034f1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408034f1"]])

export default __exports__